import { render } from "./BaseInputCheckRadio.vue?vue&type=template&id=52a711fb"
import script from "./BaseInputCheckRadio.vue?vue&type=script&lang=js"
export * from "./BaseInputCheckRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__